import { render } from "./Studio.vue?vue&type=template&id=3db99348"
import script from "./Studio.vue?vue&type=script&lang=js"
export * from "./Studio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__